import React from 'react'
import PropTypes from 'prop-types'

const AddSubscribers = (props) => {
  const { color = '#00B2AD', classes = 'w-20' } = props
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <g clipPath="url(#clip0_10369_34225)">
        <path
          d="M13 12.45C13.4833 11.9167 13.8542 11.3083 14.1125 10.625C14.3708 9.94167 14.5 9.23333 14.5 8.5C14.5 7.76667 14.3708 7.05833 14.1125 6.375C13.8542 5.69167 13.4833 5.08333 13 4.55C14 4.68333 14.8333 5.125 15.5 5.875C16.1667 6.625 16.5 7.5 16.5 8.5C16.5 9.5 16.1667 10.375 15.5 11.125C14.8333 11.875 14 12.3167 13 12.45ZM18.5 20.5V17.5C18.5 16.9 18.3667 16.3292 18.1 15.7875C17.8333 15.2458 17.4833 14.7667 17.05 14.35C17.9 14.65 18.6875 15.0375 19.4125 15.5125C20.1375 15.9875 20.5 16.65 20.5 17.5V20.5H18.5ZM20.5 13.5V11.5H18.5V9.5H20.5V7.5H22.5V9.5H24.5V11.5H22.5V13.5H20.5ZM8.5 12.5C7.4 12.5 6.45833 12.1083 5.675 11.325C4.89167 10.5417 4.5 9.6 4.5 8.5C4.5 7.4 4.89167 6.45833 5.675 5.675C6.45833 4.89167 7.4 4.5 8.5 4.5C9.6 4.5 10.5417 4.89167 11.325 5.675C12.1083 6.45833 12.5 7.4 12.5 8.5C12.5 9.6 12.1083 10.5417 11.325 11.325C10.5417 12.1083 9.6 12.5 8.5 12.5ZM0.5 20.5V17.7C0.5 17.1333 0.645833 16.6125 0.9375 16.1375C1.22917 15.6625 1.61667 15.3 2.1 15.05C3.13333 14.5333 4.18333 14.1458 5.25 13.8875C6.31667 13.6292 7.4 13.5 8.5 13.5C9.6 13.5 10.6833 13.6292 11.75 13.8875C12.8167 14.1458 13.8667 14.5333 14.9 15.05C15.3833 15.3 15.7708 15.6625 16.0625 16.1375C16.3542 16.6125 16.5 17.1333 16.5 17.7V20.5H0.5ZM8.5 10.5C9.05 10.5 9.52083 10.3042 9.9125 9.9125C10.3042 9.52083 10.5 9.05 10.5 8.5C10.5 7.95 10.3042 7.47917 9.9125 7.0875C9.52083 6.69583 9.05 6.5 8.5 6.5C7.95 6.5 7.47917 6.69583 7.0875 7.0875C6.69583 7.47917 6.5 7.95 6.5 8.5C6.5 9.05 6.69583 9.52083 7.0875 9.9125C7.47917 10.3042 7.95 10.5 8.5 10.5ZM2.5 18.5H14.5V17.7C14.5 17.5167 14.4542 17.35 14.3625 17.2C14.2708 17.05 14.15 16.9333 14 16.85C13.1 16.4 12.1917 16.0625 11.275 15.8375C10.3583 15.6125 9.43333 15.5 8.5 15.5C7.56667 15.5 6.64167 15.6125 5.725 15.8375C4.80833 16.0625 3.9 16.4 3 16.85C2.85 16.9333 2.72917 17.05 2.6375 17.2C2.54583 17.35 2.5 17.5167 2.5 17.7V18.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_10369_34225">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

AddSubscribers.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(AddSubscribers)
